import React, { useState } from "react";
import { useMutation, useQuery } from "react-query";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { getShifts } from "../../../../MyApi/shifts";
import { postCuriosShifts } from "../../../../MyApi/curior";
import { toast } from "react-toastify";

const ShiftsModal = ({ isOpen, closeModal, id, refetch, storeId }) => {
  const [shiftId, setShiftId] = useState("");
  const mutation = useMutation({
    mutationKey: ["postcuriorShift"],
    mutationFn: (postData) => postCuriosShifts(postData, id),
    onSuccess: (data) => {
      toast.success(`${data.message}`);
      refetch();
      closeModal();
    },
    onError: (error) => {
      toast.error(`${error.response.data.message}`);
    },
  });
  const { data, isLoading } = useQuery("getshifts", () => getShifts(storeId));
  const shifts = data?.data.templates || [];

  const handleChange = (e) => {
    setShiftId(e.target.value);
  };
  const handlePostRequest = () => {
    mutation.mutate({
      shift_template_id: shiftId,
      courier_id: id,
    });
  };
  return (
    <Modal isOpen={isOpen}>
      <ModalHeader>
        <h5>إضافة موعد عمل</h5>
        <p className="desc text-start">أضف موعد عمل لسائق</p>
      </ModalHeader>
      <ModalBody>
        <div className="add">
          <label htmlFor="" className="form-label">
            موعد العمل
          </label>
          <select
            name=""
            id=""
            className="form-select"
            onChange={handleChange}
            disabled={isLoading}
          >
            <option value="">
              {" "}
              {isLoading ? "جاري تحميل المواعيد" : " اختر موعد"}
            </option>
            {shifts.map((shift, i) => (
              <option key={i} value={shift.id}>
                {shift.name}
              </option>
            ))}
          </select>
        </div>
        <div className="d-flex gap-2 mt-3">
          <button
            className="btn btn-primary"
            onClick={handlePostRequest}
            disabled={mutation.isLoading}
          >
            {" "}
            {mutation.isLoading ? "جار الإضافة" : "تأكيد الإضافة"}
          </button>
          <button className="btn btn-white" onClick={closeModal}>
            إلغاء
          </button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default ShiftsModal;
